module.exports = __webpack_public_path__ + "img/topic2.3aa99775.png";